module.exports = __webpack_public_path__ + "assets/img/we-work-logo.92e60f74.png";